import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'diario-oficial/login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'publicacoes',
    loadChildren: () => import('./publicacao/publicacao.module').then(m => m.PublicacaoModule)
  },
  {
    path: 'secoes',
    loadChildren: () => import('./secao/secao.module').then(m => m.SecaoModule)
  },
  {
    path: 'subsecoes',
    loadChildren: () => import('./subsecao/subsecao.module').then(m => m.SubsecaoModule)
  },
  {
    path: 'parametros',
    loadChildren: () => import('./parametro/parametro.module').then(m => m.ParametroModule)
  },
  {
    path: 'leis-compiladas',
    loadChildren: () => import('./lei-compilada/lei-compilada.module').then(m => m.LeiCompiladaModule)
  },
  {
    path: 'estatisticas',
    loadChildren: () => import('./estatistica/estatistica.module').then(m => m.EstatisticaModule)
  },
  {
    path: 'orgaos',
    loadChildren: () => import('./core/orgao/orgao.module').then(m => m.OrgaoModule)
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./usuario-do/usuario-do.module').then(m => m.UsuarioDoModule)
  },
  {
    path: 'doe',
    loadChildren: () => import('./doe/doe.module').then(m => m.DoeModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
